import React, { startTransition, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  drawingNamesState,
  excludeDrawingNamesState,
  userState,
} from "../../../states/userState";
import { WithOutContext as ReactTags } from "react-tag-input";
import classes from "./CreateDocumentTags.module.scss";
import {
  foreColorCode,
  foreColorPagination,
  foreColorPaginationError,
} from "../../../commons/colors";
import { Divider } from "@mui/material";
import classNames from "classnames";

/** 文字列をスペース・カンマで分割して返す共通関数 */
function splitInputText(text) {
  return text
    .split(/[\s\u3000,、]+/) // 半角/全角スペース, 半角/全角カンマ
    .map((t) => t.trim()) // 前後空白を除去
    .filter(Boolean); // 空文字列を除外
}
const CreateDrawingTags = () => {
  const [drawingNames, setDrawingNames] = useRecoilState(drawingNamesState);
  const [exludeDrawingNames, setExcludeDrawingNames] = useRecoilState(
    excludeDrawingNamesState
  );
  const [drawingNamesForUi, setDrawingNamesForUi] = useState(drawingNames);
  const [exludeDrawingNamesForUi, setExcludeDrawingNamesForUi] =
    useState(exludeDrawingNames);
  const user = useRecoilValue(userState);
  const isLiteMode = user?.mode === "lite";
  const inputKeywordClassName = classNames(classes.keywordInput, {
    [classes.keywordInputLight]: isLiteMode,
    [classes.keywordInputDark]: !isLiteMode,
  });
  const inputExcludeKeywordClassName = classNames(classes.excludeKeywordInput, {
    [classes.excludeKeywordInputLight]: isLiteMode,
    [classes.excludeKeywordInputDark]: !isLiteMode,
  });
  //キーワードで絞るタグの登録
  const handleAddDrawingName = (tag) => {
    // 入力文字列を分割
    const splittedTexts = splitInputText(tag.text);

    // すでに 10 個なら追加しない (もしくは必要に応じて処理を変える)
    if (drawingNames.length >= 10) return;

    // UI 表示用
    setDrawingNamesForUi((prev) => {
      const next = [...prev];
      splittedTexts.forEach((text) => {
        if (next.length < 10) {
          next.push(text);
        }
      });
      return next;
    });

    // recoilState 用
    startTransition(() => {
      setDrawingNames((prev) => {
        const next = [...prev];
        splittedTexts.forEach((text) => {
          if (next.length < 10) {
            next.push(text);
          }
        });
        return next;
      });
    });
  };

  const handleDeleteDrawingName = (index) => {
    setDrawingNamesForUi(drawingNamesForUi.filter((_, i) => i !== index));
    startTransition(() => {
      setDrawingNames(drawingNames.filter((_, i) => i !== index));
    });
  };

  //キーワードで除外するタグの登録
  const handleAddExcludeDrawingName = (tag) => {
    const splittedTexts = splitInputText(tag.text);

    if (exludeDrawingNames.length >= 10) return;

    setExcludeDrawingNamesForUi((prev) => {
      const next = [...prev];
      splittedTexts.forEach((text) => {
        if (next.length < 10) {
          next.push(text);
        }
      });
      return next;
    });

    startTransition(() => {
      setExcludeDrawingNames((prev) => {
        const next = [...prev];
        splittedTexts.forEach((text) => {
          if (next.length < 10) {
            next.push(text);
          }
        });
        return next;
      });
    });
  };

  const handleDeleteExcludeDrawingName = (index) => {
    setExcludeDrawingNamesForUi(
      exludeDrawingNamesForUi.filter((_, i) => i !== index)
    );
    startTransition(() => {
      setExcludeDrawingNames(exludeDrawingNames.filter((_, i) => i !== index));
    });
  };
  return (
    <div className={classes.root}>
      <p
        className={classes.name}
        style={foreColorPagination(user?.mode ?? "lite")}
      >
        図面名
      </p>
      <Divider
        textAlign="left"
        sx={dividerStyle(
          user?.mode === "lite" ? foreColorCode("lite") : foreColorCode("dark")
        )}
        variant="fullWidth"
      ></Divider>
      <div className={classes.mainContainer}>
        <div className={classes.keywordContainer}>
          <p
            className={classes.keywordTitle}
            style={foreColorPagination(user?.mode ?? "lite")}
          >
            キーワードで絞る
          </p>
          <div>
            <ReactTags
              handleAddition={handleAddDrawingName}
              handleDelete={() => {}}
              placeholder="受注票 本体 タラップ .."
              classNames={{
                tagInput: classes.keyword, // <div> のラッパに付くクラス
                tagInputField: inputKeywordClassName, // <input> 自体に付くクラス
                tag: classes.tag, // タグ本体
                remove: classes.tagRemove, // タグの削除ボタン
              }}
            />
            <div className={classes.tagContainer}>
              {drawingNamesForUi.map((k, i) => (
                <div
                  key={i}
                  className={classes.tag}
                  onClick={() => handleDeleteDrawingName(i)}
                >
                  <span>{k}</span>
                  <span className="cursor-pointer">x</span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className={classes.keywordContainer}>
          <p
            className={classes.keywordTitle}
            style={foreColorPaginationError(user?.mode ?? "lite")}
          >
            キーワードを除外する
          </p>
          <div>
            <ReactTags
              handleAddition={handleAddExcludeDrawingName}
              handleDelete={() => {}}
              placeholder="受注票 本体 タラップ .."
              classNames={{
                tagInput: classes.keyword, // <div> のラッパに付くクラス
                tagInputField: inputExcludeKeywordClassName, // <input> 自体に付くクラス
                tag: classes.tag, // タグ本体
                remove: classes.tagRemove, // タグの削除ボタン
              }}
            />
            <div className={classes.tagContainer}>
              {exludeDrawingNamesForUi.map((k, i) => (
                <div
                  key={i}
                  className={classes.excludeTag}
                  onClick={() => handleDeleteExcludeDrawingName(i)}
                >
                  <span>{k}</span>
                  <span className="cursor-pointer">x</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const dividerStyle = (color) => {
  let styles = {
    borderColor: `${color}`, // 線の色をテーマのプライマリーカラーに設定
    fontSize: "18px",
    marginBottom: "10px",
    // Dividerにテキストがある場合、テキストのスタイルもここで定義できます
    "&::before, &::after": {
      // Dividerの線のスタイルをカスタマイズ
      borderTopColor: `${color}`, // これにより、線の色が変わります
    },
    color: `${color}`, // テキストの色を変更
    "@media (max-width: 600px)": {
      fontSize: "14px", // フォントサイズを14pxに設定
    },
  };
  return styles;
};
export default CreateDrawingTags;
